import "@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css";
import { Calendar, DayValue, Day } from "@amir04lm26/react-modern-calendar-date-picker";
import styles from './style.module.scss';

interface Props {
    label?: string;
    minimumDate?: Day;
    errorMessage?: string;
    selectedDate: DayValue;
    containerClassName?: string;
    setSelectedDate: (val: DayValue) => void;
};

function CustomCalendar(props: Props) {
    const {
        label,
        errorMessage,
        selectedDate,
        minimumDate,
        setSelectedDate,
        containerClassName,
    } = props;

    return (
        <div className={`${styles.container} ${containerClassName || ''}`}>
            {label && <span className={styles.label}>{label}</span>}
            <Calendar
                locale="en"
                value={selectedDate}
                shouldHighlightWeekends
                minimumDate={minimumDate}
                onChange={(val: DayValue) => setSelectedDate(val)}
                calendarSelectedDayClassName={styles.selectedDay}
            />
            {errorMessage && (<span className={styles.error}>{errorMessage}</span>)}
        </div>
    );
};

export default CustomCalendar;
